import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

function Category07() {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/webroutessort") // Update with actual backend URL
      .then((response) => {
        setData(response.data); // Store response in state
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  return (
  <section
  className="testimonials-category-section"
  style={{
    paddingTop: "20px",
    paddingBottom: "20px",
  }}
>
  <div className="tf-container">
    <div className="row">

      {/* Section Heading */}
      <div className="col-md-12">
        <div
          className="tf-title style-2"
          style={{ marginBottom: "20px" }}
        >
          <div className="group-title">
            <h1
              style={{
                marginBottom: "0px",
                fontSize: "30px",
              }}
            >
              Start Your Journey
            </h1>

            <p>
              Tailored services specially designed to guide you on your
              spiritual journey
            </p>
          </div>
        </div>
      </div>

      {/* Service Cards */}
      <div className="col-md-12">
        <div className="row">
          {data.map((item, index) => (
            <div
              key={index}
              className="col-lg-4 col-md-4 col-6"
            >
              <div
                className="group-category-job padding wow fadeInUp"
                style={{
                  paddingBottom: "10px",
                }}
              >
                <div
                  className="job-category-box"
                  style={{
                    width: "unset",
                    padding: "18px",
                  }}
                >
                  <div
                    className="job-category-header"
                    style={{
                      marginBottom: "0px",
                    }}
                  >

                    {/* Image */}
                    <a href={item.Fdesc || "#"}>
                      <img
                        src={
                          item.Path1 || "default-image.jpg"
                        }
                        alt={item.Named}
                        style={{
                          width: "100%",
                          height: "auto",
                          borderRadius: "10px",
                        }}
                      />
                    </a>

                    {/* Service Title */}
                    <h1
                      className="service-card-title"
                      style={{
                        marginTop: "15px",
                        marginBottom: "8px",
                        fontWeight: "600",
                        fontSize: "16px",
                      }}
                    >
                      {item.Named}
                    </h1>

                    {/* Description */}
                    <p
                      style={{
                        marginBottom: "12px",
                      }}
                    >
                      {item.Qdesc}
                    </p>

                    {/* View Service Button */}
                    <a
                      href={item.Fdesc || "#"}
                      className="service-card-button"
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "5px",
                        padding: "6px 12px",
                        border: "1px solid #ddd",
                        borderRadius: "6px",
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "#333",
                        textDecoration: "none",
                        background: "#fff",
                        transition: "all 0.2s ease",
                      }}
                    >
                      Explore Now
                      <span style={{ fontSize: "15px" }}>
                        →
                      </span>
                    </a>

                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>

  {/* Hover Styles */}
  <style>
    {`
      .job-category-box:hover .service-card-title {
        color: #fff !important;
      }
    `}
  </style>
</section>
  );
}

export default Category07;